import { defineStore } from 'pinia';
import { RequestMethod, RequestName, RequestProxy, useCaller } from '~/hydration/bridges';
import { useContactsStore } from '~/units/contacts/store';
import { ActivityTypes } from '~/units/polaris/constants';

export const usePolarisStore = defineStore('polaris', {
  state: () => {
    return {};
  },
  actions: {
    async init() {
      const contactsStore = useContactsStore();
      if (!contactsStore.neuronSessionId && contactsStore.contactInfo?.contact_id) {
        await useCaller(RequestProxy.POLARIS, RequestName.SEND_PING, 'ping', RequestMethod.POST, {}, {});
      }
    },

    async sendActivity(
      activityTypeId: ActivityTypes,
      data: {
        page_id: string;
        data?: any;
      },
    ) {
      const contactsStore = useContactsStore();
      if (contactsStore.isLogged) {
        await useCaller(
          RequestProxy.POLARIS,
          RequestName.SEND_ACTIVITY,
          'activities',
          RequestMethod.POST,
          {},
          {
            data: {
              ...data.data,
            },
            activity_type_id: activityTypeId,
            page_id: data.page_id,
          },
        );
      }
    },
  },
  getters: {},
});
